import React, { useEffect, useState } from "react";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import Slider from "react-slick";
import PrevArrow from "../LearningPaths/PrevArrow";
import NextArrow from "../LearningPaths/NextArrow";
import {
  recommendationViewClear,
  recommendationViewData,
} from "../../redux/recommendationView/actions";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import {
  ProductCardPriceInfo,
  SessionKeys,
  convertTimeFormat,
  getProcureInfo,
  redirectToPageUtil,
} from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../utils/config";
import {
  recommendationClear,
  recommendationData,
} from "../../redux/recommendation/actions";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const RecommendationEngineSection = ({ isDetailPage, isMobile }) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const { t } = useTranslation();
  const recommendationData1 = useSelector(
    (state) => state.recommendationView.recommendationViewData
  );
  const recommendationDataList = useSelector(
    (state) => state.recommendation.recommendationData
  );

  const formatProductCardDataForVideo = (coursesList) => {
    let prodArr = [];
    console.log("format data---", coursesList);
    for (let video of coursesList) {
      let tags = [];
      let logoURL = "";
      let btnTitle =
        video?.product_type === "course" ? t("Start Course") : t("Explore");

      if (video?.provider) {
        logoURL = video?.provider?.provider_img;
        tags.push(video?.provider?.display_name);
      }
      tags.push(
        video?.product_type === "course"
          ? "Course"
          : video?.product_type === "video"
          ? "Video"
          : ""
      );
      if (video?.product_type === "video") {
        if (video?.views) {
          tags.push(`${video?.views} View${video.views > 1 ? "s" : ""}`);
        }
      }
      if (video?.product_type === "course") {
        tags.push(
          `${video?.module_count} Module${video?.module_count > 1 ? "s" : ""}`
        );
        if (
          (video?.source === "ecom" || _.toLower(video?.source) === "xsel") &&
          !video?.purchased_info?.is_purchased &&
          video?.purchased_info?.selling_price != 0
        ) {
          btnTitle = t("Explore");
        } else if (
          video.crs_progress === "" ||
          video.crs_progress === undefined ||
          video.crs_progress === null ||
          video.crs_progress === 0
        ) {
          btnTitle = t("Start course");
        }
        else if (video?.progress > 0 && video?.progress < 100) {
          btnTitle = "Resume course";
        } else if (video?.progress >= 100) {
          btnTitle = "Revisit course";
        }
      }
      if (video?.second) {
        tags.push(convertTimeFormat(video.second, true));
      }

      console.log("purchased_info--", video?.purchased_info);
      let priceInfo = getProcureInfo(
        video?.purchased_info ? video?.purchased_info : ""
      );
      console.log("priceInfo--", priceInfo);
      if (priceInfo) {
        video.priceInfo = priceInfo;
      }
      video.source = _.toLower(video?.source);
      video.is_home = true;
      prodArr.push({
        id: video?.id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        is_wishlist: video?.is_addtowishlist,
        dbId: video?.list_id,
        productType: video?.product_type,
        productOrigin: video?.source,
        title: video?.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video?.thumbnail,
        tagsArray: tags,
        description: video?.description,
        duration:
          video?.product_type === "video"
            ? convertTimeFormat(video?.second, true)
            : "",
        showHeader: true,
        showLikeMenu: true,
        showProviderIcon: true,
        showPlayButton: video?.product_type === "video" ? true : false,
        showProgress: video?.product_type === "course" ? true : false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () =>
          redirectToPageUtil(
            video,
            navigate,
            authBroker,
            setCourseData,
            dispatch,
            "course",
            "",
            "",
            false,
            "",
            isMobile
          ),
        descAction: () => {},
        bannerAction: () =>
          redirectToPageUtil(
            video,
            navigate,
            authBroker,
            setCourseData,
            dispatch,
            "course",
            "",
            "",
            false,
            "",
            isMobile
          ),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        view: video?.product_type === "video" ? video?.views : 0,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        isLoading: false,
        show4: true,
      });
    }
    console.log("PROD ARR", prodArr);
    return prodArr;
  };

  const authBroker = useSelector((state) => state.auth.authBroker);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [courseData, setCourseData] = useState({});

  const [recommendedData, setRecommendedData] = useState(
    CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA
  );
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!_.isEmpty(recommendationData1) && !isDetailPage) {
      console.log("recommendationdata--", recommendationData1);
      if (recommendationData1?.status === "success") {
        let recommendationList = recommendationData1?.payload?.payload?.list;
        if (!_.isEmpty(recommendationList) && _.isArray(recommendationList)) {
          let formattedData = formatProductCardDataForVideo(recommendationList);
          setRecommendedData(formattedData);
        } else {
          setRecommendedData([]);
        }
        setIsLoading(false);
      } else {
        setRecommendedData([]);
        setIsLoading(false);
      }
    }
  }, [recommendationData1]);

  useEffect(() => {
    console.log("rdata==", recommendedData);
  }, [recommendedData]);

  useEffect(() => {
    if (!_.isEmpty(recommendationDataList) && isDetailPage) {
      if (recommendationDataList.status === "success") {
        console.log("recommendation---", recommendationDataList);
        let recommendationList = recommendationDataList?.payload?.payload?.list;
        if (!_.isEmpty(recommendationList) && _.isArray(recommendationList)) {
          let formattedData = formatProductCardDataForVideo(recommendationList);
          setRecommendedData(formattedData);
        } else {
          setRecommendedData([]);
        }
        setIsLoading(false);
      } else {
        setRecommendedData([]);
        setIsLoading(false);
      }
    }
  }, [recommendationDataList]);

  useEffect(() => {
    setIsLoading(true);
    setRecommendedData(CONFIG.INITIAL_RECOMMENDATION_PRODUCT_CARD_DATA);
    let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    setTimeout(() => {
      if (!isDetailPage) {
        dispatch(
          recommendationViewData({
            module: "myViewRecommendation",
            postData: {
              token: token ? token : "",
              language: activeLanguage ? activeLanguage : "",
            },
          })
        );
      } else if (isDetailPage) {
        dispatch(
          recommendationData({
            module: "myRecommendation",
            postData: {
              token: isMobile
                ? localStorage.getItem(SessionKeys.API_TOKEN)
                : token
                ? token
                : "",
              language: activeLanguage ? activeLanguage : "",
            },
          })
        );
      }
    }, 5000);
    return () => {
      if (isDetailPage) {
        dispatch(recommendationClear());
      } else {
        dispatch(recommendationViewClear());
      }
    };
  }, [activeLanguage]);

  return (
    <>
      <section className="recommended-section pt-5g">
        <div className="container">
          {!_.isEmpty(recommendedData) && (
            <div className="row">
              <div className="col-md-8 col-12">
                <div className="subscriptions-row">
                  {isLoading ? (
                    <h3 className="subs-course-title">
                      <ShimmerScreen case="rect" height="2rem" width="30rem" />
                    </h3>
                  ) : (
                    <h3 className="subs-course-title">
                      {t("My Recommended Learning Content")}
                    </h3>
                  )}
                  {true ? (
                    ""
                  ) : isLoading ? (
                    <span className="subscriptions-subhead">
                      <ShimmerScreen case="rect" height="1rem" width="10rem" />
                    </span>
                  ) : (
                    <span className="subscriptions-subhead"></span>
                  )}
                </div>
              </div>
              <div className="col-md-4 col-12 text-md-end">
                {isLoading ? (
                  <button type="button" className="view-all-btn">
                    <ShimmerScreen case="rect" height="3rem" width="7rem" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="view-all-btn"
                    onClick={() => {
                      if (isMobile) {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage(
                            JSON.stringify("click-on-view-all")
                          );
                        } else if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              JSON.stringify("click-on-view-all")
                            );
                          }
                        }
                      } else {
                        navigate("/learn/courses?tab=1");
                      }
                    }}
                  >
                    {t("viewAll")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                        stroke="#415385"
                        strokeWidth="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="row recommend-slide">
            <Slider {...settings}>
              {recommendedData?.length === 0
                ? ""
                : recommendedData.map((video, i) => {
                    return (
                      <ProductCardComponent {...video} key={`video-${i + 1}`} />
                    );
                  })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default RecommendationEngineSection;
